import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsPluginsMessages = defineMessages("settings-plugins", en);
